// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import 'myWorld/base/util';
import './stringFieldEditor';
import { LightweightBase64Reader } from './lightweightBase64Reader';

/**
 * Editor for file type fields
 * @name FileFieldEditor
 * @constructor
 * @extends {StringFieldEditor}
 */
myw.FileFieldEditor = myw.StringFieldEditor.extend({
    tagName: 'div',
    className: 'file-input',
    events: {
        'click .thumb-clear': 'clear'
    },

    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        this.fileLimit = parseInt(fieldDD.type.replace('file(', '').replace(')', '')) || Infinity;

        this.render();
    },

    render() {
        const self = this;
        this.$el.html('');
        this.fieldBlob = this.fieldValue ? this.fieldValue : {};

        const fileInput = $('<input/>', {
            type: 'file',
            style: 'display:none',
            change: async function() {
                const input = $(this)[0];
                self.error = '';
                if (input.files) {
                    const { name, size, lastModified, type } = input.files[0];

                    try {
                        const sizeInKb = parseInt(size / 1024);
                        if (sizeInKb > self.fileLimit) {
                            self.error = self.msg('file_size_error', {
                                size: sizeInKb,
                                max_size: self.fileLimit
                            });
                            self.render();
                            return;
                        }
                        const lightweightReader = new LightweightBase64Reader();
                        const fileContents = await lightweightReader.readFile(input.files[0]);
                        self.fieldValue = {
                            name,
                            size: sizeInKb,
                            mime_type: type,
                            last_modified: lastModified,
                            content_base64: fileContents
                        };
                        self.render();
                        self._changed();
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        }).appendTo(this.$el);

        $('<button/>', {
            class: 'field-edit-btn',
            style: 'display:inline-block',
            click: () => fileInput.click()
        })
            .text(this.msg(this.fieldBlob.name ? 'update_file' : 'add_file'))
            .button()
            .appendTo(this.$el);
        if (this.error) {
            $('<span/>', {
                style: 'display: inline-block, margin-top: 4px; color: rgb(220, 20, 60)',
                html: this.error
            }).appendTo(this.$el);
        }
        if (this.fieldBlob.name) {
            const { name } = this.fieldBlob;
            $('<div/>', {
                class: 'thumb-container',
                style: 'display: inline-block',
                html: `<span class="thumb-file-size">${name}</span>
                      <span class="thumb-clear"></span>`
            }).appendTo(this.$el);
        }
    },

    getValue() {
        return this.fieldValue;
    },

    /**
     * Clear field contents and render
     */
    clear() {
        this.fieldValue = null;
        this.render();
    },
    /**
     *  Wrap FileReader in a promise and return base64 encoded contents
     */
    readFile(file) {
        return new Promise(async (resolve, reject) => {
            let binary = '';
            //  Make sure this is divisible by 3. Current value = 3mb
            const CHUNK_SIZE = 3145728;
            let startPos = 0;

            while (startPos < file.size) {
                binary += btoa(await this._readFileChunk(file, startPos, startPos + CHUNK_SIZE));
                startPos += CHUNK_SIZE;
            }

            resolve(binary);
        });
    },

    async _readFileChunk(file, start, end) {
        return new Promise((resolve, reject) => {
            const slice = file.slice(start, end);
            let buffer = '';

            const reader = new FileReader();
            reader.onprogress = event => {
                const bytes = new Uint8Array(reader.result);
                const length = bytes.byteLength;
                for (let i = 0; i < length; i++) {
                    buffer += String.fromCharCode(bytes[i]);
                }
            };
            reader.onload = () => {
                resolve(buffer);
            };
            reader.onerror = error => reject(error);

            reader.readAsArrayBuffer(slice);
        });
    }
});

export default myw.FileFieldEditor;
